// PendingApprovalsList adapted for Household Items: single moveInDate display.
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { isSelfApproval, SELF_APPROVAL_ERROR_MSG } from '../../../../utility/selfApprovalCheck';

const PendingApprovalsList = ({
  pendingApprovals,
  currentEmployeeNumber,
  openApproveModal,
  openRejectModal,
  showApproveModal,
  setShowApproveModal,
  approveMessage,
  setApproveMessage,
  handleApproveSubmit,
  approvingLoading,
  showRejectModal,
  setShowRejectModal,
  rejectMessage,
  setRejectMessage,
  handleRejectSubmit,
  rejectingLoading
}) => {
  if (!Array.isArray(pendingApprovals) || pendingApprovals.length === 0) return null;
  const filtered = pendingApprovals.filter(item => item && item.id && (item.moveInDate || item.projectName || item.employeeName));
  if (filtered.length === 0) return null;
  const formatDisplayDate = (d) => { if (!d) return ''; const str = String(d).replace(/"+$/,''); const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/); if (!match) return ''; const [, y, m, day] = match; return `${m}/${day}/${y}`; };
  return (
    <div className="mt-4" style={{ paddingLeft: '2rem' }}>
      <div style={{ width: '50%' }}>
        <h5 style={{ fontSize: '1.2rem', marginBottom: 4 }}>Allowance Requests awaiting your review</h5>
        <div style={{ borderTop: '2px solid #bbb', width: '100%', marginBottom: 12 }} />
      </div>
      <div className="stay-benefit-cards-vertical" style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
        {filtered.map((item, idx) => {
          const empFirst = item.firstName || (item.employeeName && item.employeeName.split(' ')[0]) || '';
          const empLast = item.lastName || (item.employeeName && item.employeeName.split(' ')[1]) || '';
          const employeeLine = `${empFirst} ${empLast}`.trim();
          const projectLine = `${item.projectName || ''}`.trim();
          // No total days for single date.
          const selfApproval = isSelfApproval(currentEmployeeNumber, item.employeeNumber);
          return (
            <div key={item.id} className="stay-benefit-card" style={{ width: '100%', border: '1px solid #ddd', borderBottom: idx === filtered.length - 1 ? '1px solid #ddd' : 'none', borderRadius: 0, padding: 16, background: idx % 2 === 0 ? '#f8f9fa' : '#e9ecef', margin: 0, boxShadow: 'none' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>{employeeLine || 'Employee'}</div>
                  <div style={{ fontSize: 15, color: '#333', marginBottom: 10 }}>{projectLine || 'Project'}</div>
                  <div style={{ fontWeight: 400, fontSize: 15, color: '#000', marginBottom: 8 }}>{formatDisplayDate(item.moveInDate || item.startDate)}</div>
                  <div style={{ display: 'flex', gap: 12, marginTop: 4 }}>
                    <button type="button" className="btn btn-primary btn-sm" style={{ minWidth: 80 }} onClick={() => openApproveModal(item.id)} disabled={selfApproval}>Approve</button>
                    <button type="button" className="btn btn-secondary btn-sm" style={{ minWidth: 80, background: '#e0e0e0', color: '#333', border: 'none' }} onClick={() => openRejectModal(item.id)} disabled={selfApproval}>Reject</button>
                  </div>
                  {selfApproval && (
                    <div style={{ color: '#da291c', fontSize: 13, marginTop: 6, fontWeight: 500 }}>{SELF_APPROVAL_ERROR_MSG}</div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <Modal show={showApproveModal} onHide={() => setShowApproveModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Approve Submission</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label htmlFor="approveMessage">You may provide a message for approval (optional):</label>
            <textarea id="approveMessage" className="form-control" rows={6} value={approveMessage} onChange={e => setApproveMessage(e.target.value)} placeholder="Enter your message here..." style={{ width: '100%' }} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowApproveModal(false)}>Cancel</Button>
          <Button className="btn btn-danger" style={{ background: '#da291c', borderColor: '#da291c', minWidth: 110, position: 'relative' }} onClick={handleApproveSubmit} disabled={approvingLoading}>{approvingLoading && (<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />)}{approvingLoading ? 'Approving...' : 'Approve'}</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Reject Submission</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label htmlFor="rejectMessage">Please provide a reason for rejection:</label>
            <textarea id="rejectMessage" className="form-control" rows={6} value={rejectMessage} onChange={e => setRejectMessage(e.target.value)} placeholder="Enter your message here..." required aria-required="true" aria-describedby="rejectMessageHelp" style={{ width: '100%' }} />
            <small id="rejectMessageHelp" className="form-text text-muted">A rejection reason is required.</small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRejectModal(false)}>Cancel</Button>
          <Button className="btn btn-danger" style={{ background: '#da291c', borderColor: '#da291c', minWidth: 110, position: 'relative' }} onClick={handleRejectSubmit} disabled={!rejectMessage.trim() || rejectingLoading}>{rejectingLoading && (<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />)}{rejectingLoading ? 'Rejecting...' : 'Reject'}</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PendingApprovalsList;
